// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__2RLYp","notes":"Notes_notes__jNuza","note":"Notes_note__Pmslg","markdown":"Notes_markdown__1cfV9"};